// The presence indicator: green = in the app right now (a live app socket),
// yellow = not in the app but reachable — their phone will ring (native
// stay-reachable socket or push), gray = offline/unreachable.

import type { ReactNode } from 'react';
import type { PresenceStatus } from '@merkury/protocol';

const DOT_CLASS: Record<PresenceStatus, string> = {
  app: 'bg-ok',
  reachable: 'bg-warn',
  offline: 'bg-muted',
};

export function PresenceDot({ status }: { status: PresenceStatus }): ReactNode {
  return (
    <span
      aria-hidden="true"
      data-presence={status}
      className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full ${DOT_CLASS[status]}`}
    />
  );
}
